<template>
  <div class="breadcrumb-container">
    <div class="breadcrumb">
      <router-link to="/dashboard" class="breadcrumb-item">
        <i class="material-icons">home</i>
      </router-link>      <template v-for="(item, index) in items">
        <span class="breadcrumb-separator" :key="`sep-${index}`">
          <i class="material-icons">chevron_right</i>
        </span>
        <router-link 
          v-if="item.link && index < items.length - 1" 
          :to="item.link" 
          class="breadcrumb-item" 
          :key="`link-${index}`"
        >
          {{ item.text }}
        </router-link>
        <span 
          v-else 
          class="breadcrumb-item current" 
          :key="`text-${index}`"
        >
          {{ item.text }}
        </span>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {
    items: {
      type: Array,
      required: true,
      validator: (items) => {
        return items.every(item => 
          typeof item === 'object' && 
          typeof item.text === 'string'
        );
      }
    }
  }
};
</script>

<style scoped>
.breadcrumb-container {
  margin-bottom: 20px;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 10px 0;
  font-size: 0.95rem;
}

.breadcrumb-item {
  color: #1565c0;
  text-decoration: none;
  transition: color 0.2s ease;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.breadcrumb-item:not(.current) {
  cursor: pointer;
}

.breadcrumb-item:hover {
  color: #0d47a1;
  text-decoration: underline;
}

.breadcrumb-item.current {
  color: #555;
  font-weight: 500;
}

.breadcrumb-separator {
  color: #aaa;
  display: flex;
  align-items: center;
  margin: 0 5px;
}

.breadcrumb-separator .material-icons {
  font-size: 1.2rem;
}

.breadcrumb-item .material-icons {
  font-size: 1.2rem;
}

@media (max-width: 576px) {
  .breadcrumb {
    font-size: 0.85rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue